import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
export function CountdownTimer() {
  const [time, setTime] = useState({
    hours: 23,
    minutes: 59,
    seconds: 37
  });
  useEffect(() => {
    const interval = setInterval(() => {
      setTime(prev => {
        let {
          hours,
          minutes,
          seconds
        } = prev;
        if (seconds > 0) {
          seconds--;
        } else if (minutes > 0) {
          minutes--;
          seconds = 59;
        } else if (hours > 0) {
          hours--;
          minutes = 59;
          seconds = 59;
        } else {
          hours = 23;
          minutes = 59;
          seconds = 59;
        }
        return {
          hours,
          minutes,
          seconds
        };
      });
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const pad = (num: number) => String(num).padStart(2, '0');
  return <div className="flex gap-2 justify-center items-center" data-id="element-55">
      <TimeUnit value={pad(time.hours)} label="HS" data-id="element-56" />
      <span className="text-2xl font-bold" data-id="element-57">:</span>
      <TimeUnit value={pad(time.minutes)} label="MIN" data-id="element-58" />
      <span className="text-2xl font-bold" data-id="element-59">:</span>
      <TimeUnit value={pad(time.seconds)} label="SEG" data-id="element-60" />
    </div>;
}
function TimeUnit({
  value,
  label
}: {
  value: string;
  label: string;
}) {
  return <div className="text-center" data-id="element-61">
      <motion.div key={value} initial={{
      scale: 1.1
    }} animate={{
      scale: 1
    }} className="bg-white text-accent rounded-lg px-4 py-3 font-bold text-3xl min-w-[70px] shadow-sm" data-id="element-62">
        {value}
      </motion.div>
      <div className="text-xs mt-1 text-white/80" data-id="element-63">{label}</div>
    </div>;
}